const shouldShowProperty = ({
  isDisplayed,
  value
}) => isDisplayed && !!value;
export default shouldShowProperty;
//# sourceMappingURL=should-show-property.js.map